/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { PitrIntervalConfig } from '../models/PitrIntervalConfig';

export class PitrBackupSchedules {
  /**
  * Vault ID.
  */
  'vaultId': string;
  'intervalConfig': PitrIntervalConfig;
  /**
  * Backup retention period, in days.
  */
  'backupRetentionDays': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "intervalConfig",
      "baseName": "intervalConfig",
      "type": "PitrIntervalConfig",
      "format": ""
    },
    {
      "name": "backupRetentionDays",
      "baseName": "backupRetentionDays",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return PitrBackupSchedules.attributeTypeMap;
  }

  public constructor() {
  }
}

